// extracted by mini-css-extract-plugin
module.exports = {"rate":"Rate_rate__1UAc0","large":"Rate_large__k9wzj"};